module.exports = __webpack_public_path__ + "img/itemPic4.00b6693c.png";